import styled from '@emotion/styled';
import { Col } from 'react-styled-flexboxgrid';

import { pluckPropertyIfExists } from '../../../utils/data-transformers/theme';

import { DESKTOP_START_QUERY } from '../../../styling/mixins/responsive';

function setContentAlignment(propertyObject, propName) {
  return `
    align-items: ${
      propertyObject[propName] === 'center' ? 'center' : 'flex-start'
    };
    text-align: ${propertyObject[propName] === 'center' ? 'center' : 'left'};
  `;
}

// && hack exists to override a class + media query style from react-styled-flexboxgrid's Col styles
// This overrides a style that makes this Col display block when we want it to be flex.
const BaseTextContainer = styled(Col)`
  && {
    display: flex;
  }

  flex-direction: column;
  justify-content: center;
  margin: 0 auto;
  max-height: inherit;

  ${props => setContentAlignment(props, 'mobileAlignment')};

  ${({ theme }) =>
    pluckPropertyIfExists(
      theme,
      'Slat.mobile.contentStyles',
      'padding',
    )} @media (${DESKTOP_START_QUERY}) {
    max-width: ${({ layout }) => (layout === 'center' ? '750px' : '480px')};
    ${props => setContentAlignment(props, 'alignment')};

    ${({ theme }) =>
      pluckPropertyIfExists(theme, 'Slat.desktop.contentStyles', 'padding')};
  }

  ${({ customContentStyles }) =>
    customContentStyles ? customContentStyles : ''};
`;

export default BaseTextContainer;
